import { CASE_SET_FILE_TO_COMPARE, CASE_SET_FILE_TO_COMPARE_FAILURE } from './constants';

export function setFileToCompare(file) {
  return {
    type: CASE_SET_FILE_TO_COMPARE,
    file,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_SET_FILE_TO_COMPARE:
      return {
        ...state,
        fileToCompare: action.file,
      };
    case CASE_SET_FILE_TO_COMPARE_FAILURE:
      return {
        ...state,
        fileToCompare: null,
        fileToCompareFeedback: action.feedback,
      };

    default:
      return state;
  }
}
